class RevealOnView {
  constructor() {
    this.verticalObserver = null;
    this.horizontalObserver = null;
  }

  getHorizontalRootMargin() {
    return window.matchMedia('(max-width: 749px)').matches ? '0px 64px 0px 64px' : '0px 24px 0px 24px';
  }

  init() {
    this.registerObserver();
    this.revealAlreadyVisible();
    this.observeElements();
  }

  revealAlreadyVisible() {
    const items = document.querySelectorAll('.reveal:not(.is-visible)');
    items.forEach((item) => {
      const rect = item.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        item.classList.add('is-visible');
      }
    });
  }

  registerObserver() {
    if (this.verticalObserver && this.horizontalObserver) return;

    const revealOnce = (observer, entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;

        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    };

    // Vertical scrolling keeps a slightly delayed trigger for smoother entrance timing.
    this.verticalObserver = new IntersectionObserver(
      (entries, observer) => revealOnce(observer, entries),
      {
        root: null,
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.15,
      }
    );

    // Horizontal scrollers reveal immediately when any pixels are visible.
    this.horizontalObserver = new IntersectionObserver(
      (entries, observer) => revealOnce(observer, entries),
      {
        root: null,
        rootMargin: this.getHorizontalRootMargin(),
        threshold: 0,
      }
    );
  }

  observeElements() {
    const items = document.querySelectorAll('.reveal:not(.is-visible)');
    items.forEach((item) => {
      this.verticalObserver.unobserve(item);
      this.horizontalObserver.unobserve(item);

      const observer = this.isHorizontalContext(item) ? this.horizontalObserver : this.verticalObserver;
      observer.observe(item);
    });
  }

  isHorizontalContext(element) {
    let parent = element.parentElement;

    while (parent) {
      const style = window.getComputedStyle(parent);
      const canScrollX = /(auto|scroll|overlay)/.test(style.overflowX);
      const hasOverflowX = parent.scrollWidth - parent.clientWidth > 1;
      const usesHorizontalSnap = /^x\b/.test(style.scrollSnapType);

      if ((canScrollX && hasOverflowX) || usesHorizontalSnap) {
        return true;
      }

      parent = parent.parentElement;
    }

    return false;
  }

  // Call this after dynamic content loads
  reinit() {
    this.observeElements();
  }
}

const reveal = new RevealOnView();
reveal.init();

window.revealOnView = reveal;
